// extracted by mini-css-extract-plugin
export default {"wrapper":"LoadFormPopup_wrapper__KhOZO","decoration":"LoadFormPopup_decoration__FAho9"};